import { Button } from '@/components/ui/button'
import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import AuthLayout from '@/views/auth-layout'
import { Card } from '@/components/ui/card'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/auth/reset-link-sent')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user) {
      throw redirect({
        to: '/dashboard'
      })
    }
  },
  component: ResetLinkSentPage,
})

function ResetLinkSentPage() {
  const { t } = useTranslation()

  return (
    <AuthLayout>
      <Card className="p-6 flex flex-col items-center space-y-4 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('reset_link_sent_title')}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t('reset_link_sent_message')}
        </p>
        <Button asChild>
          <Link to="/auth/login">{t('back_to_login')}</Link>
        </Button>
      </Card>
    </AuthLayout>
  )
}
